// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=M+PLUS+1p&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.head-bar {
    display: flex;
    margin-top: 20px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 0;
    justify-content: space-between;
}

.head-bar-wide {
    display: flex;
    margin-top: 40px;
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 0;
    justify-content: space-around;
}

.m-plus-1p-regular {
    font-family: "M PLUS 1p", sans-serif;
    font-weight: 400;
    font-style: normal;
}

.custom-image {
    height: 50vh;
    /* background-color: rgb(195, 199, 198); */
    border-radius: 10%;
}
@media (min-width: 600px) {
    .custom-image {
        height: 55vh;
    }
    /* .image-item {
        border-radius: 50%;
    } */
}
.image-item {
    cursor: pointer;
    object-fit: scale-down;
   
    max-height: 50vh !important;

    max-width: 70% !important;

    /* border-radius: 15%;
    -moz-border-radius: 15%;
    -webkit-border-radius: 15%; */

    overflow: hidden;
    /* width: none !important; */
    /* width: 0; */
    /* width: fit-content !important; */
}
.image-item-short {
    cursor: pointer;
    object-fit: scale-down;
   
    max-height: 40vh !important;

    max-width: 70% !important;

    /* border-radius: 15%;
    -moz-border-radius: 15%;
    -webkit-border-radius: 15%; */

    overflow: hidden;
    /* width: none !important; */
    /* width: 0; */
    /* width: fit-content !important; */
}


.play-page {
    /* background-color: rgb(139, 92, 34) !important; */
}
.play-image {
    margin-right: auto;
    margin-left: auto;
    max-width: 90%;
    width: 90%;
}
@keyframes bounce {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-20px);
    }
    100% {
        transform: translateY(0);
    }
}
.element :hover {
    animation: bounce 2s infinite;
    /* Bouncing animation lasting 2 seconds, repeating infinitely */
}

.css-78trlr-MuiButtonBase-root-MuiIconButton-root {
    color: rgb(228, 158, 74) !important;
    background-color: rgb(241, 236, 241)  !important;
}

.answer-button {
    background-color: rgb(228, 158, 74) !important;
    border-radius: 20px !important;
}
.home-button {
    width: 2.5rem !important;
    height: 2.5rem !important;
}
.home-button-wide{
    width: 4rem !important;
    height:  4rem !important;;
}
.arrow-button {
    color: rgb(228, 158, 74) !important;
    text-shadow: 0 0 10px blue;
    /* padding: 0 5px 0 15px; */
    /* height: 5rem !important;
    width: 5rem !important; */
    font-size: 3rem !important;
}
.display-none {
    display: none;
}
.display-inherit {
    display: inherit;
}

.css-1t1j96h-MuiPaper-root-MuiDialog-paper {
    width: 90%;
    min-height: 50%;
    max-width: 100% !important;
}
.css-ypiqx9-MuiDialogContent-root {
    display: flex;
    /* justify-content: center;
    align-items: center;
    overflow: hidden; */
}
.play-circle :active {
    color: rgb(0, 0, 0);
}
.css-sghohy-MuiButtonBase-root-MuiButton-root {
    padding: 3px 12px !important;
}

.image-untouchable{
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Firefox */ /* Internet Explorer/Edge */
    user-select: none;
    pointer-events: none;

}`, "",{"version":3,"sources":["webpack://./src/pages/PlayPage.css"],"names":[],"mappings":"AACA;IACI,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,0CAA0C;IAC1C,kBAAkB;AACtB;AACA;IACI;QACI,YAAY;IAChB;IACA;;OAEG;AACP;AACA;IACI,eAAe;IACf,sBAAsB;;IAEtB,2BAA2B;;IAE3B,yBAAyB;;IAEzB;;iCAE6B;;IAE7B,gBAAgB;IAChB,4BAA4B;IAC5B,cAAc;IACd,mCAAmC;AACvC;AACA;IACI,eAAe;IACf,sBAAsB;;IAEtB,2BAA2B;;IAE3B,yBAAyB;;IAEzB;;iCAE6B;;IAE7B,gBAAgB;IAChB,4BAA4B;IAC5B,cAAc;IACd,mCAAmC;AACvC;;;AAGA;IACI,mDAAmD;AACvD;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,UAAU;AACd;AACA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,4BAA4B;IAChC;IACA;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,6BAA6B;IAC7B,+DAA+D;AACnE;;AAEA;IACI,mCAAmC;IACnC,gDAAgD;AACpD;;AAEA;IACI,8CAA8C;IAC9C,8BAA8B;AAClC;AACA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;AACA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B;AACA;IACI,mCAAmC;IACnC,0BAA0B;IAC1B,2BAA2B;IAC3B;6BACyB;IACzB,0BAA0B;AAC9B;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb;;uBAEmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACd,YAAY,EACb,2BAA2B;IAClD,iBAAiB;IACjB,oBAAoB;;AAExB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=M+PLUS+1p&display=swap\");\r\n.head-bar {\r\n    display: flex;\r\n    margin-top: 20px;\r\n    margin-left: 20px;\r\n    margin-right: 20px;\r\n    margin-bottom: 0;\r\n    justify-content: space-between;\r\n}\r\n\r\n.head-bar-wide {\r\n    display: flex;\r\n    margin-top: 40px;\r\n    margin-left: 30px;\r\n    margin-right: 30px;\r\n    margin-bottom: 0;\r\n    justify-content: space-around;\r\n}\r\n\r\n.m-plus-1p-regular {\r\n    font-family: \"M PLUS 1p\", sans-serif;\r\n    font-weight: 400;\r\n    font-style: normal;\r\n}\r\n\r\n.custom-image {\r\n    height: 50vh;\r\n    /* background-color: rgb(195, 199, 198); */\r\n    border-radius: 10%;\r\n}\r\n@media (min-width: 600px) {\r\n    .custom-image {\r\n        height: 55vh;\r\n    }\r\n    /* .image-item {\r\n        border-radius: 50%;\r\n    } */\r\n}\r\n.image-item {\r\n    cursor: pointer;\r\n    object-fit: scale-down;\r\n   \r\n    max-height: 50vh !important;\r\n\r\n    max-width: 70% !important;\r\n\r\n    /* border-radius: 15%;\r\n    -moz-border-radius: 15%;\r\n    -webkit-border-radius: 15%; */\r\n\r\n    overflow: hidden;\r\n    /* width: none !important; */\r\n    /* width: 0; */\r\n    /* width: fit-content !important; */\r\n}\r\n.image-item-short {\r\n    cursor: pointer;\r\n    object-fit: scale-down;\r\n   \r\n    max-height: 40vh !important;\r\n\r\n    max-width: 70% !important;\r\n\r\n    /* border-radius: 15%;\r\n    -moz-border-radius: 15%;\r\n    -webkit-border-radius: 15%; */\r\n\r\n    overflow: hidden;\r\n    /* width: none !important; */\r\n    /* width: 0; */\r\n    /* width: fit-content !important; */\r\n}\r\n\r\n\r\n.play-page {\r\n    /* background-color: rgb(139, 92, 34) !important; */\r\n}\r\n.play-image {\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n    max-width: 90%;\r\n    width: 90%;\r\n}\r\n@keyframes bounce {\r\n    0% {\r\n        transform: translateY(0);\r\n    }\r\n    50% {\r\n        transform: translateY(-20px);\r\n    }\r\n    100% {\r\n        transform: translateY(0);\r\n    }\r\n}\r\n.element :hover {\r\n    animation: bounce 2s infinite;\r\n    /* Bouncing animation lasting 2 seconds, repeating infinitely */\r\n}\r\n\r\n.css-78trlr-MuiButtonBase-root-MuiIconButton-root {\r\n    color: rgb(228, 158, 74) !important;\r\n    background-color: rgb(241, 236, 241)  !important;\r\n}\r\n\r\n.answer-button {\r\n    background-color: rgb(228, 158, 74) !important;\r\n    border-radius: 20px !important;\r\n}\r\n.home-button {\r\n    width: 2.5rem !important;\r\n    height: 2.5rem !important;\r\n}\r\n.home-button-wide{\r\n    width: 4rem !important;\r\n    height:  4rem !important;;\r\n}\r\n.arrow-button {\r\n    color: rgb(228, 158, 74) !important;\r\n    text-shadow: 0 0 10px blue;\r\n    /* padding: 0 5px 0 15px; */\r\n    /* height: 5rem !important;\r\n    width: 5rem !important; */\r\n    font-size: 3rem !important;\r\n}\r\n.display-none {\r\n    display: none;\r\n}\r\n.display-inherit {\r\n    display: inherit;\r\n}\r\n\r\n.css-1t1j96h-MuiPaper-root-MuiDialog-paper {\r\n    width: 90%;\r\n    min-height: 50%;\r\n    max-width: 100% !important;\r\n}\r\n.css-ypiqx9-MuiDialogContent-root {\r\n    display: flex;\r\n    /* justify-content: center;\r\n    align-items: center;\r\n    overflow: hidden; */\r\n}\r\n.play-circle :active {\r\n    color: rgb(0, 0, 0);\r\n}\r\n.css-sghohy-MuiButtonBase-root-MuiButton-root {\r\n    padding: 3px 12px !important;\r\n}\r\n\r\n.image-untouchable{\r\n    -webkit-touch-callout: none; /* iOS Safari */\r\n    -webkit-user-select: none; /* Safari */\r\n    -moz-user-select: none; /* Firefox */\r\n    -ms-user-select: none; /* Internet Explorer/Edge */\r\n    user-select: none;\r\n    pointer-events: none;\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
